module.exports = __webpack_public_path__ + "img/seminar-1982.ae61a506.jpg";